module.exports = __webpack_public_path__ + "img/sample_map9.29793994.png";